import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxPermissionsModule } from 'ngx-permissions';

import { FeatureModule } from 'v2/shared/feature/feature.module';

// COMPONENTS
import { MaterialCustomModule } from '../../material-custom.module';

// MODULES
import { SharedComponentsModule } from '../../shared-components.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { StringTransformationPipe } from '../shared/pipes/string-transformation.pipe';
import { SharedModule } from '../shared/shared.module';
import { UiModule } from '../ui/ui.module';

import { DirectiveModule } from './../shared/directives/directive.module';
import {
  PurchaseOrderItemsComponent,
  PurchaseOrderItemFormComponent,
  PurchaseOrderItemInputComponent,
  PurchaseOrderItemLotDropdownComponent,
  PurchaseOrderSendToContactsComponent,
  PurchaseOrderShipmentsComponent,
  PurchaseOrderShipmentsTableComponent,
  PurchaseOrderShipmentsFiltersComponent,
  PurchaseOrderShipmentsFormComponent,
  PurchaseOrderShipmentExtraCostTableComponent,
  PurchaseOrderShipmentDetailsComponent,
} from './components';

const components = [
  PurchaseOrderItemsComponent,
  PurchaseOrderItemFormComponent,
  PurchaseOrderItemInputComponent,
  PurchaseOrderItemLotDropdownComponent,
  PurchaseOrderSendToContactsComponent,
  PurchaseOrderShipmentsComponent,
  PurchaseOrderShipmentsTableComponent,
  PurchaseOrderShipmentsFiltersComponent,
  PurchaseOrderShipmentsFormComponent,
  PurchaseOrderShipmentExtraCostTableComponent,
  PurchaseOrderShipmentDetailsComponent,
];

const angularModules = [CommonModule, ReactiveFormsModule, RouterModule];

const lumModules = [
  SharedComponentsModule,
  SharedModule,
  MaterialCustomModule,
  ReactiveFormsModule,
  UiModule,
  PipeModule,
  DirectiveModule,
];

const libModules = [NgxPermissionsModule]

const standalonePipes = [
  // Standalone pipes
  StringTransformationPipe,
];

@NgModule({
  declarations: [...components],
  imports: [...angularModules, ...lumModules, ...standalonePipes, ...libModules, FeatureModule],
  exports: [...components, ...lumModules],
})
export class PurchaseOrderModule {}
